import { z } from 'zod';
import { TaskInputSchema, TaskSchema } from '../../entities/task';
/**
 * What an app hands `ctx.tasks.create` (worker side) and the host parses before
 * any repository is touched. `ref` names the app record the task is about,
 * `url` is where the assignee goes to act on it; both land in `source`.
 */ export const AppTaskCreateRequestSchema = TaskInputSchema.extend({
    ref: z.string().trim().min(1).max(200).optional(),
    url: z.string().url().max(2000).optional()
});
/** The created task as the worker sees it: the wire form of the entity. */ export const AppTaskSchema = TaskSchema;
/** The tasks this app made about one of its records (`source.ref`), open ones only. */ export const AppTaskByRefRequestSchema = z.object({
    ref: z.string().trim().min(1).max(200)
});
/** One task this app made, to complete or cancel. */ export const AppTaskIdRequestSchema = z.object({
    taskId: z.string().min(1)
});

//# sourceMappingURL=app-tasks.schema.js.map